import { defineStore, _GettersTree } from "pinia";
import useAppStore from "./app";
import { zoomOutMobile } from "@/helpers/deviceHelper";
import * as LOG from "@/log";

export interface Rule {
  key: InterfaceStateType;
  id?: string;
  state: string | boolean;
}


export enum InterfaceStateType {
  ShowWidget = "ShowWidget",
}

interface State {
  rules: Rule[];
  lastViewContentState: string;
}

export type GetRule = (key: InterfaceStateType, id?: string) => Rule;
export type HasRule = (key: InterfaceStateType, id?: string) => boolean;

interface Getters extends _GettersTree<State> {
  rule(state: State): GetRule;
  has(state: State): HasRule;
}

interface Actions {
  set(rule: Rule): void;
  toggle(key: InterfaceStateType, id?: string): void;

}

const useViewstateStore = defineStore<"viewstate", State, Getters, Actions>("viewstate", {
  state: () => ({
    rules: [],
    lastViewContentState: '',
  }),
  getters: {
    rule: (state) => (key: InterfaceStateType) => state.rules.find((r) => r.key === key),
    has: (state) => (key: InterfaceStateType, id?: string) => !!state.rules.find((r) => r.key === key && (id == null || r.id == id)),
  },
  actions: {
    set(rule: Rule) {
      const exists = this.rules.find((r) => r.key === rule.key);
      if (exists) {
        exists.state = rule.state;
      } else {
        this.rules.push(rule);
      }
    },
    toggle(key: InterfaceStateType, id?: string) {
      const exists = this.rules.find((r) => r.key === key && (id == null || r.id == id));
      if (exists) {
        // remove rule
        const index = this.rules.findIndex(r => r.key === key && (id == null || r.id == id));
        if (index > -1) {
          this.rules.splice(index, 1,);
        }
      } else {
        this.rules.push({ key, state: true, id: (id || null) });
      }

      // on mobile force zoom out to show chat widget
      if (key == InterfaceStateType.ShowWidget && useAppStore().deviceShowFullScreen) {
        const k: Rule = this.rules.find((r) => r.key === key && (id == null || r.id == id));
        if (k && k.state) {
          LOG.debug("zoom out for mobile chat widget")
          zoomOutMobile();
        } else {
          LOG.debug("reset mobile zoom")
          zoomOutMobile(this.lastViewContentState);
        }
      }


    }
  },
  persist: {
    enabled: true,
    strategies: [{
      key: "tick-chatwidget-viewstate",
      storage: window.sessionStorage
    }]
  },
});

export default useViewstateStore;
